<template>
  <div class="trip-card-on-map">
    <Column class="trip-card-on-map__wrapper">
      <Row justify="between">
        <Column class="trip-card-on-map__meta">
          <Row v-if="params && params.tags && params.tags.length > 0"
               class="trip-card-on-map__badges -m-h-5"
               wrap>
            <Badge v-for="badge in params.tags"
                   :key="`badge-trip-card-on-map-${badge.id}`"
                   :params="{text: badge.name, colors: {
                       text: '#ffffff', background: badge.color}}"/>
          </Row>
          <span v-if="params && params.type"
                class="trip-card-on-map__type">{{$type(params.type)}}</span>
          <span v-if="params && params.title"
                class="trip-card-on-map__title">{{params.title}}</span>
        </Column>
        <Column>
          <img class="trip-card-on-map__image"
               :src="params.images[0]"
               alt/>
        </Column>
      </Row>
      <Row class="trip-card-on-map__additions"
           justify="between">
        <Column>
          <Icon class="trip-card-on-map__another-icon"
                xlink="duration"
                viewport="0 0 20 20"/>
          <span>{{params.duration}}</span>
        </Column>
        <Column>
          <Icon class="trip-card-on-map__another-icon"
                xlink="route"
                viewport="0 0 20 20"/>
          <span>{{params.distance}}</span>
        </Column>
        <div>
          <Rating :params="{id: params.id,
                            component: 'Column',
                            align: 'start',
                            type: 'trips',
                            rating: params.rating,
                            currentUserRating: params.currentUserRating}"/>
        </div>
        <Column justify="end">
          <span v-on:click.prevent="toLink(`${$locale.base}${params.link}`)">
            {{ $t('service.details') }}</span>
        </Column>
        <Column>
          <Favorite :params="{id, entity, favorited}"/>
          <span>{{ $t('service.bookmark') }}</span>
        </Column>
      </Row>
    </Column>
  </div>
</template>

<script>
export default {
  name: 'TripCardOnMap',
  props: {
    params: {},
  },
  methods: {
    toLink(link) {
      this.$router.push(link);
    },
  },
  computed: {
    id() {
      return this?.params?.id;
    },
    entity() {
      return this?.params?.entity;
    },
    favorited() {
      return this?.params?.favorited;
    },
  },
};
</script>
